import React from "react";
import { Link } from "react-router-dom";

/**
 * /folio — internal preview gallery for the 10 newly generated manuscript
 * plates. Used to review consistency before integrating into chapters.
 *
 * NOT linked from the public nav. Visit directly at /folio.
 */

const API = `${process.env.REACT_APP_BACKEND_URL || ""}/api/media`;

const PLATES = [
  { slug: "01-seed-selection", title: "I — Seed Selection", target: "Chapter III · Step 01" },
  { slug: "02-cultivation", title: "II — Cultivation", target: "Chapter III · Step 02" },
  { slug: "03-harvest", title: "III — Harvest", target: "Chapter III · Step 03" },
  { slug: "04-curing-barn", title: "IV — Curing Barn", target: "Chapter III · Step 04" },
  { slug: "05-fermentation", title: "V — Fermentation", target: "Chapter III · Step 05" },
  { slug: "06-aging", title: "VI — Aging", target: "Chapter III · Step 06" },
  { slug: "07-master-blender", title: "VII — Master Blender", target: "Chapter III · Step 07 + Chapter IV plate" },
  { slug: "08-rolling-table", title: "VIII — Rolling Table", target: "Chapter III · Step 08" },
  { slug: "09-final-cigar", title: "IX — Final Cigar", target: "Chapter III · Step 09 + Chapter V plate" },
  { slug: "10-archive-desk", title: "X — Archive Desk", target: "Chapter VI · Archive plate" },
];

export default function FolioPreview() {
  return (
    <div className="min-h-screen bg-pearl text-tobacco">
      <header className="border-b border-tobacco/20">
        <div className="max-w-[1480px] mx-auto px-6 md:px-12 py-6 flex items-baseline justify-between">
          <div>
            <div className="font-mono text-[10px] tracking-widest2 uppercase text-tobacco/55">
              Internal · Plate Review
            </div>
            <h1 className="font-display italic text-tobacco text-[28px] md:text-[36px] leading-tight mt-1">
              The Folio — manuscript plate preview
            </h1>
          </div>
          <Link
            to="/"
            className="font-mono text-[10px] tracking-widest2 uppercase text-tobacco hover:opacity-70 transition-opacity duration-500"
          >
            ← Back to manuscript
          </Link>
        </div>
      </header>

      <main className="max-w-[1480px] mx-auto px-6 md:px-12 py-10 grid grid-cols-1 lg:grid-cols-2 gap-8">
        {PLATES.map((p) => (
          <figure
            key={p.slug}
            data-testid={`folio-${p.slug}`}
            className="bg-pearl-warm border border-tobacco/15"
          >
            <div className="aspect-[16/9] overflow-hidden bg-pearl flex items-center justify-center">
              <img
                src={`${API}/${p.slug}.png`}
                alt={p.title}
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
            <figcaption className="px-5 py-4 flex items-baseline justify-between gap-4">
              <div>
                <div className="font-display italic text-[18px] md:text-[20px] text-tobacco leading-tight">
                  {p.title}
                </div>
                <div className="font-mono text-[9px] tracking-widest2 uppercase text-tobacco/55 mt-1">
                  Intended → {p.target}
                </div>
              </div>
              <a
                href={`${API}/${p.slug}.png`}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-[9px] tracking-widest2 uppercase text-tobacco hover:opacity-70"
              >
                Full size →
              </a>
            </figcaption>
          </figure>
        ))}
      </main>

      <footer className="border-t border-tobacco/20 py-6">
        <div className="max-w-[1480px] mx-auto px-6 md:px-12 font-mono text-[9px] tracking-widest2 uppercase text-tobacco/55">
          10 plates · Gemini Nano Banana · awaiting integration approval
        </div>
      </footer>
    </div>
  );
}
